import React from 'react';
import PropTypes from 'prop-types';

const RevealImage = ({ imageUrl }) => {
  return (
    <div className="media">
      <a href={imageUrl} data-behavior="lightbox">
        <img alt="Reveal element" src={imageUrl} />
      </a>
      <a
        href={imageUrl}
        className="mobile_img"
        target="_blank"
        rel="noreferrer"
      >
        <img alt="Reveal element" src={imageUrl} />
      </a>
    </div>
  );
};

RevealImage.propTypes = {
  imageUrl: PropTypes.string,
};

export default RevealImage;
